import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/balances",
  component: RouteComponent,
  children: [
    {
      path: "",
      name: "balances.index",
      component: () =>
        import(
          /* webpackChunkName: "balances-list" */ "@/views/Balances/BalancesView.vue"
        ),
      meta: {
        title: "balances",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "create",
      name: "balances.create",
      component: () =>
        import(
          /* webpackChunkName: "balances-create" */ "@/views/Balances/CreateBalanceView.vue"
        ),
      props: (route) => ({
        enterpriseId: route.query.enterpriseId,
        year: route.query.year,
      }),
      meta: {
        title: "create-balance",
        header: {
          show: true,
          buttons: {
            visualization: {
              thousands: true,
              compactOrIndirect: false,
              difference: false,
            },
          },
        },
        navbar: { show: true },
        footer: { show: true },
        fullScreen: { show: true },
      },
    },
    {
      path: ":balanceId(\\d+)",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "balances.show",
          component: () =>
            import(
              /* webpackChunkName: "balances-show" */ "@/views/Balances/BalanceView.vue"
            ),
          props: true,
          meta: {
            title: "balance",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: false,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
          },
        },
        {
          path: "edit",
          name: "balances.edit",
          component: () =>
            import(
              /* webpackChunkName: "balances-edit" */ "@/views/Balances/EditBalanceView.vue"
            ),
          props: true,
          meta: {
            title: "edit-balance",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: false,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
          },
        },
      ],
    },
    {
      path: "management/:managementBalanceId(\\d+)/edit",
      name: "balances.management.edit",
      component: () =>
        import(
          /* webpackChunkName: "balances-management-edit" */ "@/views/ManagementBalances/EditManagementBalanceView.vue"
        ),
      props: true,
      meta: {
        title: "edit-management-balance",
        header: {
          show: true,
          buttons: {
            visualization: {
              thousands: true,
              compactOrIndirect: false,
              difference: false,
            },
          },
        },
        navbar: { show: true },
        footer: { show: true },
        fullScreen: { show: true },
      },
    },
  ],
};
